module.exports = __webpack_public_path__ + "static/media/code_hero.553a034a.jpg";